import React, { useRef, useEffect, useState } from 'react'
import styled from 'styled-components'

import { ReactComponent as SketchIcon } from '../assets/icons/sketch.svg'
import { ReactComponent as EraserIcon } from '../assets/icons/eraser.svg'
import { ReactComponent as ClearIcon } from '../assets/icons/clear.svg'
import { ReactComponent as ArrowIcon } from '../assets/icons/arrow_right.svg'

const colors = ['#323232', '#b1b1b1', '#3080eb', '#f4617b']

const Sketch = () => {
	const [color, set_color] = useState('#323232')
	const [shown, set_shown] = useState(false)

	const canvas = useRef<HTMLCanvasElement>(null)
	const position = useRef({ x: 0, y: 0 })

	useEffect(() => {
		resize()
		window.addEventListener('resize', resize)
		canvas.current.addEventListener('mousemove', draw)
		canvas.current.addEventListener('mousedown', set_position)
		canvas.current.addEventListener('mouseenter', set_position)
	}, []) // eslint-disable-line

	useEffect(() => {
		const ctx = canvas.current.getContext('2d')
		ctx.lineWidth = color === '#ffffff' ? 20 : 2
		ctx.lineCap = color === '#ffffff' ? 'square' : 'round'
		ctx.strokeStyle = color
	}, [color])

	const set_position = (e) => {
		position.current.x = e.clientX
		position.current.y = e.clientY
	}

	const resize = () => {
		const ctx = canvas.current.getContext('2d')
		ctx.canvas.width = window.innerWidth
		ctx.canvas.height = window.innerHeight
	}

	const draw = (e) => {
		const ctx = canvas.current.getContext('2d')

		if (e.buttons !== 1) return

		ctx.beginPath()
		ctx.moveTo(position.current.x, position.current.y)
		set_position(e)
		ctx.lineTo(position.current.x, position.current.y)
		ctx.stroke()
	}

	const clear = () => {
		const ctx = canvas.current.getContext('2d')
		ctx.clearRect(0, 0, canvas.current.width, canvas.current.height)
	}

	const toggle_shown = () => {
		set_shown(!shown)
	}

	return (
		<>
			<SketchButton onClick={toggle_shown}>
				<SketchIcon />
			</SketchButton>

			<Container shown={shown}>
				<Bar>
					<Colors>
						{colors.map((item) => (
							<Color
								key={item}
								color={item}
								active={item === color}
								onClick={() => set_color(item)}
							/>
						))}
						<ControlButtons>
							<EraserIcon onClick={() => set_color('#ffffff')} />
							<ClearIcon onClick={clear} />
						</ControlButtons>
					</Colors>
					<ArrowButton onClick={toggle_shown}>
						<ArrowIcon />
					</ArrowButton>
				</Bar>
				<Board ref={canvas} />
			</Container>
		</>
	)
}

const Button = styled.button`
	background: none;
	border: none;
	outline: none;
	cursor: pointer;
`
const SketchButton = styled(Button)`
	position: absolute;
	right: 1rem;
	bottom: 0.5rem;
	padding: 0.5rem;
	z-index: 2;
`
const Container = styled.section<{ shown }>`
	height: 100%;
	width: 100%;
	position: fixed;
	top: 0;
	right: 0;
	background: ${({ theme: { colors } }) => colors.white};
	z-index: 4;
	display: flex;
	flex-direction: column;
	align-self: flex-end;
	overflow: hidden;
	border-left: 1px solid ${({ theme: { colors } }) => colors.grey[0]};
	transform: translateX(${({ shown }) => (shown ? '0' : '100%')});
`
const Bar = styled.div`
	position: absolute;
	bottom: 0.5rem;
	right: 1rem;
	height: 2.5rem;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 55vw;
	font-size: 0.8rem;
`
const ArrowButton = styled(Button)`
	margin-left: auto;
	display: flex;
	padding: 0.7rem;
`
const Colors = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 5px;
`
const Color = styled(Button)<{ color; active }>`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 20px;
	width: 20px;
	border: none;
	margin-right: 4px;
	background: ${(props) => props.color};
	box-shadow: ${(props) => props.active && '0px 4px 3px lightgrey'};
	margin-bottom: ${(props) => props.active && '2px'};
`
const ControlButtons = styled(Button)`
	display: flex;
	justify-content: center;
	margin-left: 0.5rem;

	> svg {
		margin-left: 7px;
	}
`
const Board = styled.canvas`
	flex: 1;
`

export default Sketch
